export function getAdminSearchUrl(
    text: string,
    brand: string,
    useAnalogs: boolean,
    client?: string
): string {
    return `/search?text=${text}&brand=${encodeURIComponent(brand)}&useAnalogs=${useAnalogs}${
        client ? `&client=${client}` : ''
    }`;
}
